import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { 
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    UncontrolledTooltip,
} from 'reactstrap';

import "./ActualizarValores.scss";
import ModalConfirmacion from "./ModalConfirmacion.js";
import ParadigmaAsyncSeeker from '../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaCurrencyInput from '../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput';
import ParadigmaDatePicker from '../../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable.js";
import api from "../../../api/api.js";
import {
    ACTUALIZACION_FIJO,
    ACTUALIZACION_PORCENTUAL,
    CATEGORIA_ESCRITURA,
    CATEGORIA_SERVICIO,
    CATEGORIA_VENTA,
} from '../constants.js'
import { Monedas } from '../../Monedas/Monedas/constants.js'
import { format, formatCurrency } from '../../../functions/functions';
import { getMonedas } from "../../../api/apicalls.js";

class ActualizarValores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaDesde: '',
            compradorId: null,
            loteoId: null,
            loteId: null,

            monedasApi: [], // Para poder fijar monedas en el estado inicial
            monedas: [],
            categorias: [CATEGORIA_VENTA],
            tipoActualizacion: null,
            valorActualizacion: '0',

            filtros:[],
            tableResponses: {},
        };
    }

    async componentDidMount() {
        const monedasApi = await getMonedas();
        const monedaPesos = monedasApi 
            ? monedasApi.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        const monedas = monedaPesos ? [monedaPesos] : [];

        this.setState({ 
            monedasApi,
            monedas,
        });
    }

    resetState = () => {
        const { monedasApi } = this.state
        const monedaPesos = monedasApi 
            ? monedasApi.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        const monedas = monedaPesos ? [monedaPesos] : [];

        this.setState({
            fechaDesde: '',
            compradorId: null,
            loteoId: null,
            loteId: null,

            monedas,
            categorias: [CATEGORIA_VENTA],
            tipoActualizacion: null,
            valorActualizacion: '0',

            filtros:[],
            tableResponses: {},
        })
    }

    agregarFiltros = (id, value) => {
        let filtro = [...this.state.filtros];
        let encontre = false;

        for (let i=0; i<=filtro.length-1; i++){
            if(filtro[i].id==id){
                if(value==''){
                    filtro.splice(i,1);
                }else{
                    filtro[i].value=value;
                }
                encontre = true;
                break;
            }
        } 
        if(!encontre){
            filtro.push({id:id, value:value});
        }
        this.setState({filtros: filtro});
    }

    /*
    * Mantiene el ultimo response de cada ParadigmaTable
    * (Nota) No se borran estos response, solo se actualizan. Esto porque 
    * con la variable 'categorias' (el del state, no el de esta funcion) ya se 
    * sabe cuales response usar.
    */
    onChangeTableResponse = (categoria, response) => {
        this.setState(prevState => ({
            tableResponses: {
                ...prevState.tableResponses,
                [categoria]: response
            }
        }))
    }

    onFechaDesdeChange = (fechaDesde) => {
        this.setState({ fechaDesde })
    }

    onCompradorChange = (comprador) => {
        const compradorId = comprador ? comprador.id : null;

        this.setState({ compradorId })
    }

    onLoteoChange = (loteo) => {
        const loteoId = loteo ? loteo.id : null;

        this.setState({ 
            loteoId,
            loteId: null,
        })
    }

    onLoteChange = (lote) => {
        const loteId = lote ? lote.id : null;

        this.setState({ loteId })
    }

    onMonedasChange = (monedas) => {
        this.setState({ monedas })
    }

    onCategoriasChange = (categorias) => {
        this.setState({ categorias: categorias.map(item => item.id)})
    }

    onTipoActualizacionChange = (tipoActualizacion) => {
        this.setState({ 
            valorActualizacion: '0',
            tipoActualizacion: tipoActualizacion ? tipoActualizacion.id : null,
        })
    }

    onValorActualizacionChange = (valorActualizacion) => {
        this.setState({ valorActualizacion })
    }

    getValorActualizacionSymbol = () => {
        const { tipoActualizacion, monedas  } = this.state

        if (tipoActualizacion == ACTUALIZACION_FIJO) {
            if (monedas && monedas.length > 0)
                return monedas.map(m => m.simbolo).join("/")
        }

        if (tipoActualizacion == ACTUALIZACION_PORCENTUAL)
            return "%";

        return "";
    }

    conversionPorcentajeDecimal = (porcentajeEntero) => {
        return porcentajeEntero / 100
    }

    getValorActualizado = (valorViejo) => {
        const { tipoActualizacion, valorActualizacion } = this.state
        const valor = parseFloat(valorActualizacion)
        var valorActualizado = valorViejo

        if (tipoActualizacion == ACTUALIZACION_FIJO)
            valorActualizado = valorViejo + valor

        if (tipoActualizacion == ACTUALIZACION_PORCENTUAL)
            valorActualizado = valorViejo * (1 + this.conversionPorcentajeDecimal(valor))

        return format(valorActualizado)
    }

    getMonedasId = () => {
        const { monedas } = this.state
        const monedalist =  monedas.map(moneda => moneda.id)
        return monedalist
    }

    render() {
        const { 
            fechaDesde, 
            compradorId,
            loteoId,
            loteId,

            monedas,
            categorias,
            valorActualizacion,
            tipoActualizacion,

            tableResponses,
        } = this.state;

        const cantidadFilas = 10;
        const columns = [
            {
                Header: "id",
                id: "id",
                accessor: "id",
                width: 100,
                show: false,
                private: true,
            },
            {
                Header: "Estado",
                id: "estado",
                accessor: "estado",
                width: 50,
                show: false,
                private: true,
            },
            {
                Header: "N° Cuota",
                id: "nroCuota",
                accessor: d => d.nroCuota,
                width: 60,
                filterable: false,
                show: true,
            },
            {
                Header: "Comprador/es",
                id: "clientes",
                accessor: d => d.clientes,
                filterable: false,
                show: true,
            },
            {
                Header: "Loteo",
                id: "loteo",
                accessor: d => d.loteo,
                filterable: false,
                show: true,
            },
            {
                Header: "Lote",
                id: "lote_nombre",
                width: 50,
                accessor: d => d.lote_nombre,
                className: "text-center",
                filterable: false,
                show: true,
            },
            {
                Header: "Vencimiento",
                id: "vencimiento",
                width: 100,
                className: "text-center",
                accessor: d => moment(d.vencimiento).format('DD/MM/YYYY'),
                filterable: false,
                show: true,
            },
            {
                Header: "Moneda",
                id: "moneda",
                accessor: "moneda",
                show: false,
                private: true,
            },
            {
                Header: "Monto",
                id: "monto",
                className: "text-right",
                accessor: d => `${d.moneda.simbolo} ${format(d.monto)}`,
                filterable: false,
                show: true,
                exportCurrency: true,
            },
            // (Nota) Se usa un dummy para poder modificar libremente el valor
            // de la columna sin afectar a las otras columnas.
            // El monto actualizado se calcula en el backend.
            {
                Header: "Monto Actualizado",
                id: "dummy_monto_actualizado",
                className: "text-right",
                accessor: d => `${d.moneda.simbolo} ${this.getValorActualizado(d.monto)}`,
                filterable: false,
                show: true,
                exportCurrency: true,
            },
        ]

        // Filtros que solo aplican para el preview
        // (Nota) Los filtros que aplican para la actualizacion estan en el
        // ModalConfirmacion
        let outerFilter = [];
        if (fechaDesde) {
            outerFilter.push({
                id: 'fecha_desde',
                value: moment(fechaDesde).format('YYYY/MM/DD')
            });
        }
        if (compradorId) {
            outerFilter.push({
                id: 'comprador_id',
                value: compradorId
            });
        }
        if (loteoId) {
            outerFilter.push({
                id: 'loteo_id',
                value: loteoId
            });
        }
        if (loteId) {
            outerFilter.push({
                id: 'lote_id',
                value: loteId
            });
        }
        if (monedas && monedas.length > 0) {
            outerFilter.push({
                id: 'monedas_id',
                value: this.getMonedasId().toString()
            });
        }

        // Validacion para no cambiar el monto fijo de multiples monedas.
        // (Nota) Es porque la cotizacion es distinta, no tiene sentido asignar
        // el mismo valor para pesos y dolares.
        const isTipoActualizacionFijo = (tipoActualizacion == ACTUALIZACION_FIJO);
        const isTipoActualizacionEmpty = (tipoActualizacion == null);
        const masDeUnaMonedaSeleccionada = (monedas && monedas.length > 1);
        const tipoFijoConMuchasMonedas = (isTipoActualizacionFijo && masDeUnaMonedaSeleccionada);
        const isInputValorActualizacionDisabled = isTipoActualizacionEmpty || tipoFijoConMuchasMonedas;

        // Se cuentan todas las cuotas que van a ser actualizadas a traves
        // de todas las tablas de vista previa.
        let previewTotalCantidadCuotas = 0;
        categorias.forEach(categoria =>{
            const cantidadCategoria = tableResponses[categoria] &&
                tableResponses[categoria].meta && 
                tableResponses[categoria].meta.totalRowsFiltered
                ? tableResponses[categoria].meta.totalRowsFiltered
                : 0;

            previewTotalCantidadCuotas += cantidadCategoria;
        })

        // Campos que faltan completar
        const faltanCompletarParaConfirmar = [
            (fechaDesde == '') && '(Fecha) A partir del',
            (monedas.length < 1) && 'Moneda/s',
            (tipoFijoConMuchasMonedas) && 'Solo se puede actualizar el valor fijo de a una sola Moneda',
            (categorias.length < 1) && 'Categoria/s',
            (tipoActualizacion == null) && 'Tipo Actualizacion',
        ].filter(Boolean);

        return (
            <Row className="m-0 ventana-actualizar-valores">
                <Col className="col-12 mt-2">
                    <Card body className="border-0 p-0 mb-3">
                        <CardTitle className="text-center py-2 mb-0 col-color">
                            Actualizar Valores de Cuotas
                            <Button
                                id="infoBotonConfirmacion"
                                color="warning"
                                className="rounded boton-info-actualizacion"
                            >
                                <i className="fa fa-question" />
                            </Button>
                            <UncontrolledTooltip target="infoBotonConfirmacion">
                                Solo se pueden actualizar cuotas que cumplan las siguientes condiciones:
                                <ul>
                                    <li>
                                        No está Pagada.
                                    </li>
                                </ul>
                            </UncontrolledTooltip>
                        </CardTitle>

                        <CardBody>
                            <Row>
                                <Col className="col-5">
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"A partir del"}
                                        inputComponent={
                                            <div className={"date-filterFDH has-valueFDH"}>
                                                <ParadigmaDatePicker
                                                    datetime={false}
                                                    value={moment(this.state.fechaDesde).format('DD/MM/YYYY')}
                                                    onChange={this.onFechaDesdeChange}
                                                />
                                                <div className="date-filterFDH__buttons">
                                                    <button
                                                        className="date-filterFDH__button date-filterFDH__button-close"
                                                        onClick={() => this.onFechaDesdeChange('')}
                                                    >
                                                        <i className={'fa fa-times'}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Comprador"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                url={api.clientes.select}
                                                parameters={{
                                                    paginationEnabled: false,
                                                    sort: ['apellido']
                                                }}
                                                displayField="nombre_completo"
                                                value={compradorId}
                                                onChange={this.onCompradorChange}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Loteo"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                url={api.loteos.loteos_select}
                                                parameters={{
                                                    paginationEnabled: false,
                                                    sort: ['nombre']
                                                }}
                                                value={loteoId}
                                                onChange={this.onLoteoChange}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Lote"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                optionRenderer={opts => `${opts.manzana} - ${opts.numero}`}
                                                valueRenderer={opts => `Manzana: ${opts.manzana} - Número: ${opts.numero}`}
                                                url={loteoId ? api.loteos.lotesSelect : ''}
                                                parameters={{
                                                    paginationEnabled: false,
                                                    id: loteoId,
                                                    sort: ['manzana'],
                                                }}
                                                disabled={!loteoId}
                                                value={loteId}
                                                onChange={this.onLoteChange}
                                            />
                                        }
                                    />

                                </Col>

                                <Col className="col-5">
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Moneda/s"}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                url={api.monedas.monedas}
                                                multiselect={true}
                                                parameters={{
                                                    paginationEnabled:false,
                                                }}
                                                value={this.getMonedasId()}
                                                onChange={this.onMonedasChange}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Categoria/s"
                                        md={[3, 9]}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                url={undefined}
                                                multiselect={true}
                                                optionDefault={[
                                                    { id: CATEGORIA_VENTA, nombre: CATEGORIA_VENTA },
                                                    { id: CATEGORIA_SERVICIO, nombre: CATEGORIA_SERVICIO},
                                                    { id: CATEGORIA_ESCRITURA, nombre: CATEGORIA_ESCRITURA},
                                                ]}
                                                value={categorias}
                                                onChange={this.onCategoriasChange}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Tipo Actualizacion"
                                        md={[3, 9]}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                url={undefined}
                                                optionDefault={[
                                                    { id: ACTUALIZACION_FIJO, nombre: ACTUALIZACION_FIJO },
                                                    { id: ACTUALIZACION_PORCENTUAL, nombre: ACTUALIZACION_PORCENTUAL },
                                                ]}
                                                value={tipoActualizacion}
                                                onChange={this.onTipoActualizacionChange}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        md={[3, 9]}
                                        label={"Valor"}
                                        inputComponent={
                                            <ParadigmaCurrencyInput
                                                className="form-control monto w-100"
                                                disabled={isInputValorActualizacionDisabled}
                                                symbol={this.getValorActualizacionSymbol()}
                                                value={formatCurrency(valorActualizacion)}
                                                onChange={valor => this.onValorActualizacionChange(valor)}
                                            />
                                        }
                                    />
                                </Col>

                                <Col className="col-2 container-confirmacion">
                                    <ParadigmaLabeledInput 
                                        disabled={true}
                                        classNames={["invisible-space","invisible-space"]}
                                    />
                                    <ParadigmaLabeledInput 
                                        disabled={true}
                                        classNames={["invisible-space","invisible-space"]}
                                    />
                                    <ParadigmaLabeledInput 
                                        disabled={true}
                                        classNames={["invisible-space","invisible-space"]}
                                    />
                                    <div className="boton-confirmacion">
                                        <ModalConfirmacion
                                            fechaDesde={fechaDesde}
                                            compradorId={compradorId}
                                            loteoId={loteoId}
                                            loteId={loteId}
                                            monedasId={this.getMonedasId()}
                                            previewTotalCantidadCuotas={previewTotalCantidadCuotas}
                                            categorias={categorias}
                                            tipoActualizacion={tipoActualizacion}
                                            valorActualizacion={valorActualizacion}
                                            faltanCompletarParaConfirmar={faltanCompletarParaConfirmar}
                                            reset={this.resetState}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

                <Col className="col-12">
                    { 
                        categorias.includes(CATEGORIA_VENTA) &&
                            <Fragment>
                                <ParadigmaTable
                                    id="table-ventas"
                                    buttons={[]}
                                    defaultPageSize={cantidadFilas}
                                    columns={columns}
                                    apiUrl={api.ventas.previewActualizarValores}
                                    // exportUrl={api.ventas.listCuotas}
                                    title={"Ventas (Vista Previa)"}
                                    outerFilter={outerFilter}
                                    onChangeTableResponse={(response) => this.onChangeTableResponse(CATEGORIA_VENTA, response)}
                                />
                                <div className='paradigma-table-separator'/>
                            </Fragment>
                    }
                    { 
                        categorias.includes(CATEGORIA_SERVICIO) &&
                            <Fragment>
                                <ParadigmaTable
                                    id="table-servicios"
                                    buttons={[]}
                                    defaultPageSize={cantidadFilas}
                                    columns={columns}
                                    apiUrl={api.servicios.previewActualizarValores}
                                    // exportUrl={api.ventas.listCuotas}
                                    title={"Servicios (Vista Previa)"}
                                    outerFilter={outerFilter}
                                    onChangeTableResponse={(response) => this.onChangeTableResponse(CATEGORIA_SERVICIO, response)}
                                />
                                <div className='paradigma-table-separator'/>
                            </Fragment>
                    }
                    { 
                        categorias.includes(CATEGORIA_ESCRITURA) &&
                            <Fragment>
                                <ParadigmaTable
                                    id="table-escrituras"
                                    buttons={[]}
                                    defaultPageSize={cantidadFilas}
                                    columns={columns}
                                    apiUrl={api.escrituras.previewActualizarValores}
                                    // exportUrl={api.ventas.listCuotas}
                                    title={"Escrituras (Vista Previa)"}
                                    outerFilter={outerFilter}
                                    onChangeTableResponse={(response) => this.onChangeTableResponse(CATEGORIA_ESCRITURA, response)}
                                />
                                <div className='paradigma-table-separator'/>
                            </Fragment>
                    }
                </Col>
            </Row>
        );
    }
}

export default ActualizarValores;



// WEBPACK FOOTER //
// ./src/views/Cuotas/ActualizarValores/ActualizarValores.js